export default __webpack_public_path__ + "static/media/lastStand.da583e30.jpg";